import { render } from "./tiptop.vue?vue&type=template&id=e85b89ec&scoped=true"
import script from "./tiptop.vue?vue&type=script&lang=js"
export * from "./tiptop.vue?vue&type=script&lang=js"

import "./tiptop.vue?vue&type=style&index=0&id=e85b89ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e85b89ec"

export default script